import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register the service worker for offline shell + install prompt.
// Only enabled in production builds — `yarn start` doesn't compile the SW
// in a way that respects fresh code changes and would cache stale dev assets.
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .catch((err) => { if (process.env.NODE_ENV !== "production") console.error("SW registration failed", err); });
  });
}
